import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const PersonalityStyles = styled(OnboardingPage)`
  .personality-title {
    margin: 8px 0 24px;
  }

  ion-content {
    &::part(scroll) {
      padding: 0 24px;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .range-data {
      width: 100%;
      flex: 0;
      padding: 0 4px;
      border-radius: 8px;

      --bar-background: #262130;
      --bar-background-active: linear-gradient(
        116deg,
        #7f36f3 16.47%,
        #ed0d80 83.53%
      );
      --bar-height: 8px;
      --bar-border-radius: 8px;
      --knob-background: #ed0d80;
      --knob-size: 24px;
      --pin-background: none;
      --pin-color: none;
    }

    .range-labels {
      display: flex;
      justify-content: space-between;
      margin: 0;
    }
  }
`;
